import React, { Component } from 'react'
import PropTypes from 'prop-types'
import curry from 'lodash/curry'

import Title from './Title'
import List from './List'
import ListItem from './ListItem'
import Header from './Header'
import AddButton from './AddButton'
import DeleteButton from './DeleteButton'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'components/fulcrum/input/Input'

class Panel extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    resolutionSource: PropTypes.array.isRequired,
    sizeSource: PropTypes.array.isRequired,
    refreshRateSource: PropTypes.array.isRequired,
    vendorSource: PropTypes.array.isRequired,
    onResolutionChange: PropTypes.func.isRequired,
    onSizeChange: PropTypes.func.isRequired,
    onVendorChange: PropTypes.func.isRequired,
    onPartNumberChange: PropTypes.func.isRequired,
    onRefreshRateChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
  }

  onRemove = index => () => this.props.onRemove(index)
  onResolutionChange = index => value => this.props.onResolutionChange(index, value)
  onSizeChange = index => value => this.props.onSizeChange(index, value)
  onVendorChange = index => value => this.props.onVendorChange(index, value)
  onPartNumberChange = index => value => this.props.onPartNumberChange(index, value)
  onRefreshRateChange = index => value => this.props.onRefreshRateChange(index, value)

  generateRows = () => this.props.values.map((value, index) => {
    const {
      refreshRateSource,
      resolutionSource,
      sizeSource,
      vendorSource,
    } = this.props

    const {
      panelResolutionId,
      panelVendorId,
      panelSizeId,
      partNumber,
      panelRefreshRateId,
    } = value

    return (
      <ListItem key={index}>
        <Dropdown
          pos='left'
          onChange={this.onSizeChange(index)}
          value={panelSizeId}
          source={sizeSource}/>
        <Dropdown
          onChange={this.onResolutionChange(index)}
          value={panelResolutionId}
          source={resolutionSource}/>
        <Dropdown
          onChange={this.onRefreshRateChange(index)}
          value={panelRefreshRateId}
          source={refreshRateSource}/>
        <Dropdown
          onChange={this.onVendorChange(index)}
          value={panelVendorId}
          source={vendorSource}/>
        <Input
          value={partNumber}
          onChange={this.onPartNumberChange(index)}
        />
        <DeleteButton
          pos='rightAction'
          onClick={this.onRemove(index)}/>
      </ListItem>
    )
  })

  render() {
    const { label, onAdd } = this.props
    return (
      <div>
        <Title label={ label }/>
        <List>
          <Header/>
          { this.generateRows() }
        </List>
        <AddButton onClick={onAdd}/>
      </div>
    )
  }
}

export default Panel
